jQuery(document).ready(function ($) {
    var fadeOutTimeout = setTimeout(function () {
        $('.woocommerce-notices-wrapper .woocommerce-message').css('display', 'none').addClass('wc-message-faded')
    }, 7000) // Adjust the time as needed (5000 milliseconds = 5 seconds)

    $('.woocommerce-notices-wrapper .woocommerce-message').hover(
        function () {
            // Clear the timeout to stop the fade-out if the message is not already faded
            if (!$(this).hasClass('wc-message-faded')) {
                clearTimeout(fadeOutTimeout)
                $(this).css('opacity', '1') // Reset opacity in case it's mid-fade
                // Append a close button to the message
                $('.woocommerce-notices-wrapper .woocommerce-message').append('<button class="wc-message-close">×</button>')
            }
        },
        function () {
            // Do nothing when hover ends
        }
    )

    // Handle the click event of the close button
    $('.woocommerce-notices-wrapper').on('click', '.wc-message-close', function () {
        $(this).closest('.woocommerce-message').css({
            'overflow': 'hidden',
            'opacity': '0',
            'display': 'none'
        }).addClass('wc-message-faded')
    })

    var fadeOutTimeout = setTimeout(function () {
        $('.woocommerce-notices-wrapper .woocommerce-error').css('display', 'none').addClass('wc-message-faded')
    }, 7000) // Adjust the time as needed (5000 milliseconds = 5 seconds)

    $('.woocommerce-notices-wrapper .woocommerce-error').hover(
        function () {
            // Clear the timeout to stop the fade-out if the message is not already faded
            if (!$(this).hasClass('wc-message-faded')) {
                clearTimeout(fadeOutTimeout)
                $(this).css('opacity', '1') // Reset opacity in case it's mid-fade
                // Append a close button to the message
                $('.woocommerce-notices-wrapper .woocommerce-error').append('<button class="wc-message-close">×</button>')
            }
        },
        function () {
            // Do nothing when hover ends
        }
    )

    // Handle the click event of the close button
    $('.woocommerce-notices-wrapper').on('click', '.wc-message-close', function () {
        $(this).closest('.woocommerce-error').css({
            'overflow': 'hidden',
            'opacity': '0',
            'display': 'none'
        }).addClass('wc-message-faded')
    })
})
